module.exports = __webpack_public_path__ + "static/contact-27b6e2d22754f9a0a504e248ed3e92d6.jpg";